import { Injectable } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';

@Injectable({
    providedIn: 'root'
})
export class SpinnerService {

    spinnerCountMap = new Map<string, number>();

    constructor(private spinnerService: NgxSpinnerService) {
        console.log('Spinner Start')
    }

    showFullscreenSpinner() {

        if (this.spinnerCountMap.has('fullscreen')) {
            let spinnerCount = this.spinnerCountMap.get('fullscreen')!;

            if (spinnerCount > 0) {
                spinnerCount += 1;
                this.spinnerCountMap.set('fullscreen', spinnerCount);
            }
        } else {
            this.spinnerService.show('fullscreen');
            this.spinnerCountMap.set('fullscreen', 1);
        }

    }

    hideFullscreenSpinner() {
        if (this.spinnerCountMap.has('fullscreen')) {
            let spinnerCount = this.spinnerCountMap.get('fullscreen')!;

            spinnerCount -= 1;
            this.spinnerCountMap.set('fullscreen', spinnerCount);

            if (spinnerCount == 0) {
                this.spinnerService.hide('fullscreen');
                this.spinnerCountMap.delete('fullscreen');
            }
        }
    }

    showInComponentSpinner(spinnerName: string) {
        if (this.spinnerCountMap.has(spinnerName)) {
            let spinnerCount = this.spinnerCountMap.get(spinnerName)!;

            if (spinnerCount > 0) {
                spinnerCount += 1;
                this.spinnerCountMap.set(spinnerName, spinnerCount);
            }
        } else {
            this.spinnerService.show(spinnerName);
            this.spinnerCountMap.set(spinnerName, 1);
        }
    }

    hideInComponentSpinner(spinnerName: string) {
        if (this.spinnerCountMap.has(spinnerName)) {
            let spinnerCount = this.spinnerCountMap.get(spinnerName)!;

            spinnerCount -= 1;
            this.spinnerCountMap.set(spinnerName, spinnerCount);

            if (spinnerCount == 0) {
                this.spinnerService.hide(spinnerName);
                this.spinnerCountMap.delete(spinnerName);
            }
        }
    }

    getInComponentSpinnerStatus(spinnerName: string): boolean {
        let spinner = this.spinnerCountMap.get(spinnerName);

        return spinner != undefined;
    }

}